import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import ReactApexChart from "react-apexcharts";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { getEmployees } from "../../../core/data/redux/employee/employeeAction";
import { exportToCSV, exportToExcel, exportToPDF } from "../../../core/common/GlobalFunctions/exportTableData";
import { fetchAllDepartments } from "../../../core/data/redux/department/departmentAction";
import { fetchAll_Sort_count, fetchAll_Sort_count_monthly, fetchAll_Sort_Employee, fetchAll_Sort_Report } from "../../../core/data/redux/reports/sort_details_report/sort_details.Action";
import { ApexOptions } from "apexcharts";

interface EmployeeReportProps {
    status?: "active" | "inactive";
    department?: string;
    project?: string;
    showOnlyTable?: boolean;
}

type MonthlyLateCount = {
    month: any;
    late_employee_count: any;
};


const Sort_details_Reports: React.FC<EmployeeReportProps> = ({ status, department, project, showOnlyTable }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { employees } = useSelector((state: any) => state.employee);
    const { departments } = useSelector((state: any) => state.department);
    const [lateData, setlateData] = useState<any>([]);
    const [Count, setCount] = useState<any[]>([]);
    const [monthlycount, setmonthlycount] = useState<any>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 20;


    const getCurrentMonthDates = () => {
        const now = new Date();

        const start = new Date(now.getFullYear(), now.getMonth(), 1);
        const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);

        const format = (date: Date) => date.toISOString().split("T")[0];

        return {
            startDate: format(start),
            endDate: format(end),
        };
    };




    const { startDate: defaultStartDate, endDate: defaultEndDate } =
        getCurrentMonthDates();

    const [startDate, setStartDate] = useState(defaultStartDate);
    const [endDate, setEndDate] = useState(defaultEndDate);
    const [selectedDepartment, setSelectedDepartment] = useState<string>('');




    const handleSearch = async () => {
        if (!startDate || !endDate) {
            alert("Please select both Start Date and End Date");
            return;
        }

        const payload = {
            startDate,
            endDate,
            department: selectedDepartment ? selectedDepartment : "ALL",
        };
        const departmentpayload = payload.department
        try {
            await dispatch(fetchAll_Sort_Report({ startDate, endDate, departmentpayload }))
                .then((res) => {
                    setlateData(res.payload.data)
                })

            await dispatch(fetchAll_Sort_count({ startDate, endDate, departmentpayload }))
                .then((res) => {
                    setCount(res.payload.data)
                })

            await dispatch(fetchAll_Sort_count_monthly({ startDate, endDate, departmentpayload }))
                .then((res) => {
                    setmonthlycount(res.payload.data)
                })
        } catch (error) {
            console.error(error);
        }
    };





    useEffect(() => {
        dispatch(getEmployees());
        dispatch(fetchAllDepartments());
        dispatch(fetchAll_Sort_Report({ startDate, endDate, selectedDepartment }))
            .then((res) => {
                setlateData(res.payload.data)
            })
        dispatch(fetchAll_Sort_count({ startDate, endDate, departmentpayload: "All" }))
            .then((res) => {
                setCount(res.payload.data)
            })

        dispatch(fetchAll_Sort_count_monthly({ startDate, endDate, departmentpayload: "All" }))
            .then((res) => {
                setmonthlycount(res.payload.data)
            })
    }, [dispatch])

    const [employeeCardData, setEmployeeCardData] = useState<any>(null);
    const [selectedEmployee, setSelectedEmployee] = useState("");


    useEffect(() => {
        if (!selectedEmployee) {
            setEmployeeCardData(null);
            return;
        }

        dispatch(
            fetchAll_Sort_Employee({
                startDate,
                endDate,
                EmployeeID: selectedEmployee,
            })
        ).then((res: any) => {
            setEmployeeCardData(res.payload?.data?.[0] || null);
        });
    }, [selectedEmployee, startDate, endDate, dispatch]);
    const [circularSeries, setCircularSeries] = useState<number[]>([0]);
    const [circularLabel, setCircularLabel] = useState("0/0");

    const shortCount = Count?.[0]?.short_employee_count ?? 0;
    const totalCount = Count?.[0]?.total_employee_count ?? 0;

    const percentage =
        totalCount > 0 ? Math.round((shortCount / totalCount) * 100) : 0;


    useEffect(() => {
        if (!Count?.[0]) {
            setCircularLabel("0/0");
            return;
        }

        setCircularLabel(`${shortCount}/${totalCount}`);
    }, [shortCount, totalCount]);


    useEffect(() => {
        // Ensure Count is a valid non-empty array
        if (!Array.isArray(Count) || !Count[0]) {
            setCircularSeries([0]);
            return;
        }

        const shortCount = Number(Count[0]?.short_employee_count ?? 0);
        const totalCount = Number(Count[0]?.total_employee_count ?? 0);

        const percentage =
            totalCount > 0 ? Math.round((shortCount / totalCount) * 100) : 0;

        setCircularSeries([percentage]);
    }, [Count]);


    const circularOptions: ApexOptions = useMemo(() => ({
        chart: {
            type: "radialBar",
            height: 260,
        },
        plotOptions: {
            radialBar: {
                hollow: {
                    size: "65%",
                },
                dataLabels: {
                    name: {
                        show: true,
                        fontSize: "16px",
                    },
                    value: {
                        fontSize: "22px",
                        formatter: () => circularLabel,
                    },
                },
            },
        },
        labels: ["Short Employees"],
        colors: ["#FF4D4F"],
    }), [circularLabel]);






    // /* ------------------ Filtered Data ------------------ */
    const filteredData = useMemo(() => {
        if (!selectedEmployee) return lateData;

        return lateData.filter(
            (item: any) => String(item.EmployeeID) === selectedEmployee
        );
    }, [lateData, selectedEmployee]);


    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    const paginatedData = useMemo(() => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        return filteredData.slice(startIndex, startIndex + itemsPerPage);
    }, [filteredData, currentPage]);

    console.log(paginatedData, 'paginatedData')
    useEffect(() => {
        setCurrentPage(1); // reset page when filter/search changes
    }, [filteredData]);


    useEffect(() => {
        if (!monthlycount || monthlycount.length === 0) return;

        // Jan–Dec default 0
        const monthlyCounts = new Array(12).fill(0);

        monthlycount.forEach((item: any) => {
            // "2025-11" → ["2025", "11"]
            const [, monthStr] = item.month.split("-");
            const monthIndex = Number(monthStr) - 1; // 0-based

            if (monthIndex >= 0 && monthIndex < 12) {
                monthlyCounts[monthIndex] = Number(item.short_employee_count);
            }
        });

        setEmployeechart((prev: any) => ({
            ...prev,
            series: [
                {
                    name: "Short Employees",
                    data: monthlyCounts,
                },
            ],
        }));

    }, [monthlycount]);


    const [employeechart, setEmployeechart] = useState<any>({
        series: [
            {
                name: "Employees",
                data: new Array(12).fill(0),
            },
        ],
        chart: {
            type: "area",
            height: 180,
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "55%",
                endingShape: "rounded",
            },
        },
        colors: ["#03C95A", "#E8E9EA"],
        dataLabels: {
            enabled: false,
        },
        stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
        },
        xaxis: {
            categories: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
            ],
        },
        yaxis: {
            labels: {
                offsetX: -15,
            },
        },
        fill: {
            opacity: 1,
        },
        legend: {
            show: false,
        },
        tooltip: {
            y: {
                formatter: function (val: string) {
                    return val + " Employee";
                },
            },
        },
    });




    const employeeSummary = useMemo(() => {
        if (!selectedEmployee || filteredData.length === 0) {
            return null;
        }

        return filteredData.reduce(
            (acc: any, curr: any) => {
                acc.totalWorkHrs += Number(curr.WorkedHours || 0);
                acc.totalShortHrs += Number(curr.ShortBy || 0);

                // Assuming ProductionHours exists (adjust field if different)
                acc.totalProductionHrs += Number(curr.ProductionHours || 0);

                return acc;
            },
            {
                totalWorkHrs: 0,
                totalProductionHrs: 0,
                totalShortHrs: 0,
            }
        );
    }, [filteredData, selectedEmployee]);


    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Short Hours Report</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.adminDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">HR</li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Short Hours Report
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            <div className="mb-2">
                                <div className="dropdown">
                                    <Link
                                        to="#"
                                        className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                    >
                                        <i className="ti ti-file-export me-1" />
                                        Export
                                    </Link>
                                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                                        <li>
                                            <button
                                                onClick={() => exportToCSV(filteredData, "Short_report")}
                                                className="dropdown-item rounded-1"
                                            >
                                                <i className="ti ti-file-type-pdf me-1" />
                                                Export as CSV
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                onClick={() => exportToExcel(filteredData, "Short_report")}
                                                className="dropdown-item rounded-1"
                                            >
                                                <i className="ti ti-file-type-xls me-1" />
                                                Export as Excel{" "}
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                onClick={() => exportToPDF(filteredData, "Short_report")}
                                                className="dropdown-item rounded-1"
                                            >
                                                <i className="ti ti-file-type-xls me-1" />
                                                Export as PDF{" "}
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="head-icons ms-2">
                                <CollapseHeader />
                            </div>
                        </div>
                    </div>
                    {/* /Breadcrumb */}
                    <div className="row">
                        <div className="col-12">
                            {/* Parent Card */}
                            <div className="card">
                                {/* Header with Date Filters */}
                                <div className="card-header">
                                    <div className="row align-items-end g-2">
                                        <div className="col-md-3">
                                            <label className="form-label">Start Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={startDate}
                                                onChange={(e) => setStartDate(e.target.value)}
                                            />
                                        </div>

                                        <div className="col-md-3">
                                            <label className="form-label">End Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={endDate}
                                                onChange={(e) => setEndDate(e.target.value)}
                                            />
                                        </div>


                                        <div className="col-md-3">
                                            <label className="form-label">Department</label>
                                            <select
                                                className="form-select"
                                                value={selectedDepartment}
                                                onChange={(e) => setSelectedDepartment(e.target.value)}
                                            >
                                                <option value="">All Departments</option>
                                                {departments?.map((dept: any) => (
                                                    <option key={dept.Id} value={dept.Id}>
                                                        {dept.Name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-md-3">
                                            <button
                                                className="btn btn-primary w-100"
                                                onClick={handleSearch}
                                            >
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* Body */}
                                <div className="card-body">
                                    <div className="row">
                                        {/* LEFT SIDE – Four Boxes */}


                                        <div className="col-xl-4 col-lg-5 col-md-12 mb-3">
                                            <div className="card h-100">
                                                <div className="card-header border-0">
                                                    <h5>Short Hrs Employees / Total Employees Overview</h5>
                                                </div>
                                                <div className="card-body d-flex justify-content-center align-items-center">
                                                    <ReactApexChart
                                                        key={`${percentage}-${circularLabel}`}
                                                        options={circularOptions}
                                                        series={[percentage]}
                                                        type="radialBar"
                                                        height={260}
                                                    />

                                                </div>
                                            </div>
                                        </div>


                                        {/* RIGHT SIDE – Chart */}
                                        <div className="col-xl-8 col-lg-7 col-md-12">
                                            <div className="card h-100">
                                                <div className="card-header border-0">
                                                    <h5>Number of Short Employee Each Month</h5>
                                                </div>
                                                <div className="card-body">
                                                    <ReactApexChart
                                                        options={employeechart}
                                                        series={employeechart.series}
                                                        type="area"
                                                        height={220}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card">
                        {/* ================= Header ================= */}
                        <div className="card-header d-flex align-items-center justify-content-between py-2">
                            <h5 className="mb-0">List</h5>

                            <div className="d-flex align-items-end gap-2">
                                <div>
                                    <label className="form-label fw-semibold mb-1">
                                        Filter by Employee
                                    </label>
                                    <select
                                        className="form-select form-select-sm"
                                        value={selectedEmployee}
                                        onChange={(e) => setSelectedEmployee(e.target.value)}
                                        style={{ minWidth: "220px" }}
                                    >
                                        <option value="">All Employees</option>
                                        {employees?.map((emp: any) => (
                                            <option key={emp.EmployeeID} value={emp.EmployeeID}>
                                                {emp.Name} ({emp.EmployeeNumber})
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <button
                                    className="btn btn-outline-secondary btn-sm"
                                    onClick={() => setSelectedEmployee("")}
                                >
                                    Reset
                                </button>
                            </div>
                        </div>


                        {/* ================= Employee Summary Cards ================= */}
                        {selectedEmployee && employeeCardData && (
                            <div className="p-3 border-bottom">
                                <div className="row g-3">
                                    {/* Total Work Hours */}
                                    <div className="col-md-4">
                                        <div className="card h-100 shadow-sm">
                                            <div className="card-body text-center">
                                                <h6 className="text-muted mb-1">Total Work Hours</h6>
                                                <h4 className="fw-bold text-primary">
                                                    {employeeCardData.TotalShiftHours || "00:00:00"}
                                                </h4>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Total Production Hours */}
                                    <div className="col-md-4">
                                        <div className="card h-100 shadow-sm">
                                            <div className="card-body text-center">
                                                <h6 className="text-muted mb-1">Total Production Hours</h6>
                                                <h4 className="fw-bold text-success">
                                                    {employeeCardData.TotalWorkedHours || "00:00:00"}
                                                </h4>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Total Short Hours */}
                                    <div className="col-md-4">
                                        <div className="card h-100 shadow-sm">
                                            <div className="card-body text-center">
                                                <h6 className="text-muted mb-1">Total Short Hours</h6>
                                                <h4 className="fw-bold text-danger">
                                                    {employeeCardData.TotalShortHours || "00:00:00"}
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}


                        {/* ================= Body ================= */}
                        <div className="card-body p-0">
                            <div className="table-responsive">
                                {/* ================= Table ================= */}
                                <table className="table table-hover align-middle mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th>#</th>
                                            <th>Employee</th>
                                            <th>Date</th>
                                            <th>First Login</th>
                                            <th>Last Logout</th>
                                            <th>Shift</th>
                                            <th>Worked Hours</th>
                                            <th className="text-danger">Short By</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {paginatedData.length === 0 ? (
                                            <tr>
                                                <td colSpan={8} className="text-center py-4 text-muted">
                                                    No short working records found
                                                </td>
                                            </tr>
                                        ) : (
                                            paginatedData.map((item: any, index: number) => (
                                                <tr key={index}>
                                                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>

                                                    <td>
                                                        <div className="fw-semibold">{item.EmployeeName}</div>
                                                        <small className="text-muted">{item.EmployeeNumber}</small>
                                                    </td>

                                                    <td>{new Date(item.PunchDate).toLocaleDateString()}</td>
                                                    <td>{item.FirstLogin}</td>
                                                    <td>{item.LastLogout}</td>
                                                    <td>{item.ShiftName}</td>
                                                    <td>{item.WorkedHours}</td>

                                                    <td className="fw-semibold text-danger">
                                                        {item.ShortBy}
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>

                                {/* ================= Pagination (INSIDE SCROLL) ================= */}
                                {totalPages > 1 && (
                                    <div className="d-flex justify-content-between align-items-center p-3 border-top">
                                        <span className="text-muted">
                                            Page {currentPage} of {totalPages}
                                        </span>

                                        <nav>
                                            <ul className="pagination mb-0">
                                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                    <button
                                                        className="page-link"
                                                        onClick={() => setCurrentPage(prev => prev - 1)}
                                                    >
                                                        Previous
                                                    </button>
                                                </li>

                                                {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                                                    <li
                                                        key={page}
                                                        className={`page-item ${currentPage === page ? "active" : ""}`}
                                                    >
                                                        <button
                                                            className="page-link"
                                                            onClick={() => setCurrentPage(page)}
                                                        >
                                                            {page}
                                                        </button>
                                                    </li>
                                                ))}

                                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                                    <button
                                                        className="page-link"
                                                        onClick={() => setCurrentPage(prev => prev + 1)}
                                                    >
                                                        Next
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div >
                <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
                    <p className="mb-0">2024 - 2025© hrmtree.</p>
                    <p>
                        Developed By{" "}
                        <Link to="#" className="text-primary">
                            Leadchain Systems
                        </Link>
                    </p>
                </div>
            </div >
            {/* /Page Wrapper */}
        </>
    );
};

export default Sort_details_Reports;
